import { useState } from 'react';
import { useUI } from '../../context/AppContext.jsx';
import { useRobotConnection } from '../../hooks/useRobotConnection.js';

export default function RobotModal() {
  const { showRobotModal, setShowRobotModal } = useUI();
  const { connectToRobot, connectToRobotFTP } = useRobotConnection();
  const [host, setHost] = useState('192.168.1.99');
  const [username, setUsername] = useState('root');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [isConnecting, setIsConnecting] = useState(false);

  const handleConnect = async () => {
    if (!host || !username || !password) {
      setStatus('Please fill in all fields');
      return;
    }

    setIsConnecting(true);
    setStatus('Connecting...');
    try {
      await connectToRobot(host, username, password);
    } catch (error) {
      setStatus(`Error: ${error.message}`);
    } finally {
      setIsConnecting(false);
    }
  };

  const handleConnectFTP = async () => {
    setIsConnecting(true);
    setStatus('Connecting via FTP...');
    try {
      await connectToRobotFTP();
    } catch (error) {
      setStatus(`Error: ${error.message}`);
    } finally {
      setIsConnecting(false);
    }
  };

  if (!showRobotModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-bg-secondary rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Connect to Robot</h2>
          <button
            onClick={() => setShowRobotModal(false)}
            className="text-text-secondary hover:text-text-primary text-2xl"
          >
            ×
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-text-secondary mb-1">Robot IP Address:</label>
            <input
              type="text"
              value={host}
              onChange={(e) => setHost(e.target.value)}
              className="w-full bg-bg-tertiary border border-border rounded px-3 py-2 text-text-primary"
              placeholder="192.168.1.99"
            />
          </div>
          <div>
            <label className="block text-sm text-text-secondary mb-1">Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-bg-tertiary border border-border rounded px-3 py-2 text-text-primary"
              placeholder="root"
            />
          </div>
          <div>
            <label className="block text-sm text-text-secondary mb-1">Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-bg-tertiary border border-border rounded px-3 py-2 text-text-primary"
              placeholder="Enter password"
            />
          </div>
          {status && (
            <div className={`text-sm ${status.includes('Error') ? 'text-error' : 'text-info'}`}>
              {status}
            </div>
          )}
          <div className="flex flex-col gap-2 pt-4">
            <button
              onClick={handleConnect}
              disabled={isConnecting}
              className="bg-primary text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors disabled:opacity-50"
            >
              {isConnecting ? 'Connecting...' : 'Connect via SSH'}
            </button>
            <button
              onClick={handleConnectFTP}
              disabled={isConnecting}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-colors disabled:opacity-50"
            >
              {isConnecting ? 'Connecting...' : 'Connect via FTP'}
            </button>
            <button
              onClick={() => setShowRobotModal(false)}
              className="bg-bg-tertiary text-text-primary px-4 py-2 rounded hover:bg-bg-hover transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

